import React, { useContext, useEffect, useState, useRef } from 'react';
import { StyledBrandModalDiv } from './index.styles';
// import { BrandFiltersComponentsProps } from './../../index.types';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import { SearchFilterContext } from '../../organisms/SearchResults/index.context';
import {
  SearchFacetsConstants,
  SearchFacetsList,
  SearchFacetsListCodes,
} from '../../organisms/SearchResults/index.constant';
import { eventUtil } from '@marriott/mi-ui-library-shop';
import { Button } from '@marriott/mi-ui-library';
import { BrandsFilterComponent } from './BrandFilters';
import {
  SearchStateExtendsType,
  SearchStateFilterObj,
  SearchFacetsResponse,
} from '../../organisms/SearchResults/store/store.type';
import { getSearchAppliedFilter, SearchActions } from '../../organisms/SearchResults/store/store.action';
import clsx from 'clsx';
import { useSessionUpdateContext } from '../../context/SessionUpdateContext';
import { enableBoostBrands, updateQueryParams } from '../../organisms/SearchResults/lib/helper';
import { Modal } from '@marriott/mi-ui-library';
import { usePageContext } from '../../context/PageContext';
import { useCheckBreakpoint } from '@marriott/mi-ui-library';
import { getOSInformation } from '../../utils/src/utils';

export const BrandsModalComponent: React.FC<{
  filterData?: Array<SearchFacetsResponse>;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ filterData, setFetchCurrencyConversionFactors }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent, setFeatureSelected, isMapViewEnabled }: any = useContext(renderedData);
  const { searchQueryState, setSearchQuery } = useContext(SearchFilterContext);
  const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();
  const { headersData } = usePageContext();
  const [popupOpenState, setPopupOpenState] = useState(false);
  const clickTrackingLoc = 'Phoenix Search Results';
  const [currFilterData, setCurrFilterData] = useState<Array<SearchFacetsResponse> | undefined>(filterData);

  // const brands = searchQueryState?.filter?.filter((key) => key.type.code === SearchFacetsList.brand)[0];
  const [filterSelectionData, setFilterSelectionData] = useState<SearchStateExtendsType | undefined>(
    searchQueryState[SearchFacetsList.brand]
  );
  const [deviceType, setDeviceType] = useState<'android' | 'ios' | 'other'>('other');

  const isActive =
    searchQueryState[SearchFacetsList.brand] && Object.keys(searchQueryState[SearchFacetsList.brand] ?? {}).length;

  const bodyRef = useRef<HTMLBodyElement | null>(null);
  const isDesktop = useCheckBreakpoint('viewportM'); // check if viewport is desktop till 768px

  useEffect(() => {
    bodyRef.current = document.body as HTMLBodyElement;
  }, []);

  const onFilterChange = (type: SearchFacetsList, data: SearchStateFilterObj): void => {
    let arr1: SearchStateExtendsType = { ...filterSelectionData };
    if (filterSelectionData) {
      arr1[type] = data;
    } else {
      arr1 = {
        [type]: data,
      };
    }
    setFilterSelectionData(arr1);
    setInteractionsSelected({ ...interactionsSelected, brands: true });
    setFetchCurrencyConversionFactors(true);
    eventUtil.dispatch('updateShopPageFilterModalValues', { ...searchQueryState, ...arr1 });
  };

  const applyBtnHandler = (): void => {
    const payload = filterSelectionData === undefined ? { [SearchFacetsList.brand]: {} } : filterSelectionData;
    const brands = Object.values((payload?.[SearchFacetsList.brand] as SearchStateFilterObj) ?? {});

    if (enableBoostBrands() === true) {
      const params = new URLSearchParams(window.location.search);
      params?.delete('showMore');
      window.history.replaceState({}, headersData?.referer, decodeURIComponent(`?${params}`));
    }

    updateQueryParams(
      {
        brands,
      },
      ['brands'],
      headersData?.referer
    );

    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.offset]: 0,
      },
    });
    setSearchQuery({ type: SearchActions.setApplyFilter, payload: payload });
    setSearchQuery({
      type: SearchActions.setQuery,
      payload: {
        [SearchFacetsConstants.facets]: {
          ...getSearchAppliedFilter(payload, searchQueryState),
        },
        [SearchFacetsConstants.options]: {
          ...searchQueryState.search[SearchFacetsConstants.options],
          [SearchFacetsConstants.includeTaxes]: searchQueryState[SearchFacetsConstants.includeTaxes],
          [SearchFacetsConstants.unavailableProperties]: searchQueryState[SearchFacetsConstants.unavailableProperties],
        },
      },
    });
  };

  useEffect(() => {
    setFilterSelectionData(searchQueryState[SearchFacetsList.brand]);
  }, [searchQueryState[SearchFacetsList.brand]]);

  useEffect(() => {
    if (!popupOpenState && !isMapViewEnabled && bodyRef.current) {
      bodyRef.current.style.overflow = 'auto';
    }
  }, [popupOpenState]);

  useEffect(() => {
    setCurrFilterData(filterData);
  }, [filterData]);

  useEffect(() => {
    setDeviceType(getOSInformation());
  }, []);

  return (
    <StyledBrandModalDiv>
      <Button
        callback={(): void => {
          setCurrFilterData(undefined);
          if (!isMapViewEnabled && bodyRef.current) {
            bodyRef.current.style.overflow = 'hidden';
          }
          setPopupOpenState(!popupOpenState);
          setFilterSelectionData(searchQueryState[SearchFacetsList.brand]);
        }}
        className={clsx(
          'm-button-primary-inverse t-label-alt-m filter-option-button sm-search-result-all-filter-component-button',
          isActive ? 'active' : ''
        )}
        buttonCopy={jsonContent?.brandsLabel}
        custom_click_track_value={`${clickTrackingLoc}| Filter Selection: Brands |internal`}
      ></Button>

      {/* TODO - remove old markup after unit testing on environment */}
      {/* <button
        type="button"
        onClick={(): void => {
          setPopupOpenState(!popupOpenState);
          setFilterSelectionData(searchQueryState[SearchFacetsList.brand]);
        }}
        className={
          't-label-alt-m filter-option-button sm-search-result-all-filter-component-button ' +
          (isActive ? 'active' : '')
        }
      >
        {jsonContent?.brandsLabel}*/}
      {/* <span className={`icon-dropdown-${popupOpenState?'up':'down'}`} /> */}
      {/* </button> */}
      {popupOpenState && (
        <Modal
          className={`custom-scrollbar  ${popupOpenState ? '' : 'close-popup-header'}`}
          show={true}
          handleBlur={true}
          popupOpenState={popupOpenState}
          setPopupOpenState={setPopupOpenState}
          allFilterPopUp={true}
          onClose={(): void => {
            setCurrFilterData(undefined);
          }}
          role="dialog"
          labelledBy="ModalPopup"
          modalId="ModalPopup"
          flexLayout={true}
        >
          <Modal.Header
            // labelIcon=""
            labelText={jsonContent?.brandsLabel}
            // cancelLabel=""
            popupHeaderOnCLoseFunc={setPopupOpenState}
            customHeadingClass={isDesktop ? 't-subtitle-xl' : 't-subtitle-l'}
            flexLayout={true}
          >
            <div className="filter-by-title">{jsonContent?.brandsLabel}</div>
          </Modal.Header>
          <Modal.Body className={clsx('all-filters', 'custom-scrollbar', deviceType)} flexLayout={true}>
            <BrandsFilterComponent
              onItemSelect={onFilterChange}
              clearFilterState={filterSelectionData}
              allFilterPopUp={false}
              itemList={currFilterData?.filter(key => key.type.code === SearchFacetsListCodes.brand)[0]}
            />
          </Modal.Body>
          <Modal.Footer
            clearClickHandler={(): void => {
              setCurrFilterData(undefined);
              setFilterSelectionData(undefined);
            }}
            applyBtnClickHandler={applyBtnHandler}
            popupHeaderOnCLoseFunc={setPopupOpenState}
            clearButtonLabel={jsonContent.clearLabel}
            applyLabel={jsonContent.applyLabel}
            setFeatureSelected={setFeatureSelected}
            clickTrackingLoc={clickTrackingLoc}
            className={'pop-up-footer'}
            flexLayout={true}
          />
        </Modal>
      )}
    </StyledBrandModalDiv>
  );
};
